import type { TFunction } from 'i18next';

import type { UploadStatus } from '@/shared/api/upload';

/**
 * The line shown under the progress of an upload that is retrying, waiting for the network or was resumed (large files are
 * sent in chunks, see shared/api/resumableUpload.ts); undefined while it is simply sending. `namespace` is the i18n
 * namespace of the caller, which must contain the `upload.*` keys of the shared set (`shared`) — Disk has its own copy.
 */
export function describeUploadStatus(
  status: UploadStatus,
  t: TFunction,
  fileSize: (bytes: number) => string,
  prefix = 'files',
): string | undefined {
  switch (status.kind) {
    case 'retrying':
      return t(`${prefix}.retrying`, { attempt: status.attempt });
    case 'offline':
      return t(`${prefix}.offline`);
    case 'resumed':
      return t(`${prefix}.resumed`, { size: fileSize(status.offset) });
    case 'uploading':
      return undefined;
  }
}
